import React from "react";

interface Partner {
  name: string;
  image?: string;
}

interface SponsorsProps {
  partners: Partner[];
}

const Sponsors: React.FC<SponsorsProps> = ({ partners }) => {
  if (!partners || partners.length === 0) return null;

  return (
    <div className="mb-4">
      <div className="text-gray-700 font-medium mb-2 flex items-center">
        <span className="mr-2">Sponsors:</span>
        <div className="flex flex-wrap gap-1">
          {partners.map((partner, idx) => (
            <span
              key={partner.name + idx}
              className="inline-flex items-center bg-gray-100 rounded-full px-2 py-0.5 text-xs font-medium text-gray-800"
            >
              {partner.image && (
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-4 h-4 rounded-full mr-1 object-cover"
                />
              )}
              {partner.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sponsors;